import { render, staticRenderFns } from "./ExpertViewPage.vue?vue&type=template&id=a44ce5ee&"
import script from "./ExpertViewPage.vue?vue&type=script&lang=js&"
export * from "./ExpertViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports